import React from "react";
import "./header.css"


export class Header extends React.Component {

    constructor(props) {
        super(props);
    }

    render(){

        return(
            <div className={"header"}/>
        )
    }

}

export default {Header}